import { useEnergyAssetDetail } from "@features/ax/assetRegistry/assets/hooks";
import { GenericTable } from "@shared/components/GenericTable";
import { TableColumn } from "@shared/types/table";
import { PAGE_SIZE } from "@shared/utils/constants";
import { useState } from "react";
import { useParams } from "react-router-dom";

export const ReadingHistoryTab: React.FC<any> = () => {
  const { id, energyAsset } = useParams();
  const { data: assetEnergyDetail } = useEnergyAssetDetail(energyAsset);

  const [currentPage, setCurrentPage] = useState(1);
  // Assessment History Table Configuration
  const historyColumns: TableColumn[] = [
    {
      key: "updated Date",
      header: "Updated Date",
    },
    {
      key: "previousReading",
      header: "Previous Reading",
    },
    {
      key: "previousReadingDate",
      header: "Previous Date",
    },
    {
      key: "currentReading",
      header: "Current Reading",
    },
    {
      key: "currentReadingDate",
      header: "Current Date",
    },
    {
      key: "consumption",
      header: "Consumption",
    },
  ];

  return (
    <div className="space-y-6">
      <GenericTable
        data={assetEnergyDetail?.assetHistoryData || []}
        columns={historyColumns}
        rowKey="id"
        actionsType="icons"
        emptyMessage="No assessment history found"
        searchPlaceholder="Search assessments..."
        pagination={{
          currentPage,
          totalPages: Math.ceil(assetEnergyDetail?.count / PAGE_SIZE),
          totalItems: assetEnergyDetail?.count,
          itemsPerPage: PAGE_SIZE,
          startItem: (currentPage - 1) * PAGE_SIZE + 1,
          endItem: Math.min(currentPage * PAGE_SIZE, assetEnergyDetail?.count),
        }}
        onPageChange={setCurrentPage}
      />
    </div>
  );
};
